import { SelectTabData, SelectTabEvent, Tab, TabList } from '@fluentui/react-components';
import { useContext } from 'react';
import { SignInContext } from '@modules/users';
import { EDetectionRefVariant } from '../../types/references.types';
import { useGroupedRefs } from '../../hooks/useGroupedRefs.hook';
import { ControlledTooltip } from '../../../../shared/components';
import { TERMINOLOGY } from '@shared/i18n';

type TProps = {
  selectedTab: EDetectionRefVariant;
  setSelectedTab: (tab: EDetectionRefVariant) => void;
  groupedByType: ReturnType<typeof useGroupedRefs>['groupedByType'];
};
const RefModeTabs = ({ selectedTab, setSelectedTab, groupedByType }: TProps) => {
  const { organization } = useContext(SignInContext);

  return (
    <TabList
      size="medium"
      selectedValue={selectedTab}
      onTabSelect={(_: SelectTabEvent, data: SelectTabData) => setSelectedTab(data.value as EDetectionRefVariant)}
    >
      <Tab value={EDetectionRefVariant.EXTERNAL}>
        Document {TERMINOLOGY.reference.lowerPlural} ({groupedByType.referencesCount})
      </Tab>
      <ControlledTooltip
        content={`Section ${TERMINOLOGY.reference.lowerPlural} are not configured for your organization. Please contact support to enable this feature.`}
        enable={!organization.isSelfReferencesConfigured}
        relationship="inaccessible"
        withArrow
        positioning="after"
      >
        <Tab value={EDetectionRefVariant.SELF} disabled={!organization.isSelfReferencesConfigured}>
          Section {TERMINOLOGY.reference.lowerPlural} ({groupedByType.selfReferencesCount})
        </Tab>
      </ControlledTooltip>
    </TabList>
  );
};

export default RefModeTabs;
